import React from 'react'
import { AppShell } from '../../components/SideNav/AppShell'

// The authenticated app shell: side-rail primary nav + secondary top bar,
// with the routed page (Outlet), MSA banner and footer in the content column.
// (Replaces the former HeaderV2 horizontal top nav.)
export function LayoutAdmin() {
  return <AppShell />
}
